import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ConfigurationCaseTypeSampleTypeCreateRequest, ConfigurationCaseTypeSampleTypeResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class CaseTypeLaboratoriesRelationshipSampleTypesConfigurationServices {
    async getCaseTypeRelationshipSampleType(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationCaseTypeSampleTypeResponse>> {
        const response = await axios.put(`/configuration/laboratories/${laboratoryId}/caseTypeSampleTypes`, filterModel, { params })
        return response.data
    }

    async createCaseTypeRelationshipSampleType(laboratoryId: number, request: ConfigurationCaseTypeSampleTypeCreateRequest): Promise<ConfigurationCaseTypeSampleTypeResponse> {
        const response = await axios.post(`/configuration/laboratories/${laboratoryId}/caseTypeSampleTypes`, request)
        return response.data
    }

    async deleteCaseTypeRelationshipSampleType(laboratoryId: number, caseTypeLaboratoryIds: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete(`/configuration/laboratories/${laboratoryId}/caseTypeSampleTypes/${caseTypeLaboratoryIds}`)
        return response.data
    }
}

export const caseTypeLaboratoriesRelationshipSampleTypesConfigurationServices = new CaseTypeLaboratoriesRelationshipSampleTypesConfigurationServices()
